// extracted by mini-css-extract-plugin
module.exports = {"element":"image_element__tEy8u"};